import { mdiClose, mdiMagnify } from "@mdi/js";
import { InputAdornment, useTheme } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";
import { MiInputTextbox } from "../MiInputTextBox/MiInputTextBox";

export const MiSearchInput: React.FC<MiSearchInputProps> = ({
  value,
  handleChange,
  onFocus,
  onBlur,
  placeholder = "Search",
  disabled = false,
  className,
  style,
  textfieldProps,
  label,
  shrink,
}) => {
  const theme = useTheme();

  const clearSearch = () => {
    handleChange?.({
      target: { value: "" },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  const handleChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange?.(event);
  };

  return (
    <MiInputTextbox
      className={className}
      disabled={disabled}
      value={value}
      size="small"
      style={{
        marginLeft: theme.spacing(2),
        backgroundColor: theme.palette.common.white,
        ...style,
      }}
      handleChange={handleChangeEvent}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      label={label}
      shrink={shrink}
      textfieldProps={{
        style: { height: 34 },
        ...textfieldProps,
        startAdornment: (
          <InputAdornment position="start">
            <MiIcon path={mdiMagnify} size={0.8} color="grey" />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end" sx={{ cursor: "pointer" }}>
            <MiIcon
              path={mdiClose}
              size={0.8}
              color="grey"
              onClick={clearSearch}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

interface MiSearchInputProps {
  value: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  textfieldProps?: object;
  label?: string;
  shrink?: boolean;
}
